import { Accordion } from 'devextreme-react';
import { DataGrid, Column } from 'devextreme-react/data-grid';
import type { DataGridTypes } from 'devextreme-react/data-grid';
import PathJobResumeGroupDto from '../../classes/dtos/jobmodule/PathJobResumeGroupDto';

const RunDetailGrid = (props: DataGridTypes.MasterDetailTemplateData) => {
    const { Resume } = props.data.data;

    function CustomTitle(group: PathJobResumeGroupDto) {
        const { Label, Count } = group;
        return (
            <div>{Label + " : "} <span style={{ fontWeight: "bold", color: "green" }}>{Count}</span></div>
        );
    }

    function CustomItem(group: PathJobResumeGroupDto) {
        const { Details } = group;
        return (
            <DataGrid dataSource={Details} showBorders={true} columnAutoWidth={true}>
                <Column dataField="Scope" />
                <Column dataField="Type" />
                <Column dataField="Level" />
                <Column dataField="Details" />
            </DataGrid>
        );
    }

    return (
        <Accordion multiple={true} collapsible={true} dataSource={Resume.Groups} itemTitleRender={CustomTitle} itemRender={CustomItem} />
    );
};

export default RunDetailGrid;
